module.exports = __webpack_public_path__ + "img/kenya@4x.42e7624a.png";